import React, { useContext } from 'react'
import { LanguageContext } from '../../container/Language';
import Journey from './Journey';
import Coding from './Skills/Coding';
import Framework from './Skills/Framework';
import Knowledge from './Skills/Knowledge';
import Language from './Skills/Language';

const Resume = () => {
    const { dictionary: { resume: { journey, skills } } } = useContext(LanguageContext)

    return (
        <div className="card-inner" id="resume-card">
            <div className="card-wrap">
                <div className="content resume">
                    <div className="title">{journey.title}</div>
                    <div className="row">
                    <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
                        <div className="resume-title border-line-h">
                                <div className="icon"><i className="fa fa-briefcase"></i></div>
                                <div className="name">{journey.experience.title}</div>
                            </div>
                            <div className="resume-items">
                                <Journey items={journey.experience.items} />
                            </div>
                        </div>
                        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
                            <div className="resume-title border-line-h">
                                <div className="icon"><i className="fa fa-university"></i></div>
                                <div className="name">{journey.education.title}</div>
                            </div>
                            <div className="resume-items">
                                <Journey items={journey.education.items} />
                            </div>
                        </div>
                        <div className="clear"></div>
                    </div>
                </div>
                <div className="content skills">
                    <div className="title">{skills.title}</div>
                    <div className="row">
                        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
                            <Coding data={skills.coding} />
                        </div>
                        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
                            <Framework data={skills.framework} />
                        </div>

                        <div className="clear"></div>

                        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
                            <Knowledge data={skills.knowledge} />
                        </div>
                        <div className="col col-d-6 col-t-6 col-m-12 border-line-v">
                            <Language language={skills.language} />
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Resume